export class Company {
    _id : string;
    name: string;
    address: string;

}